import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeft16, IcoClose16, IcoInfo24 } from '@onefootprint/icons';
import * as RadixDialog from '@radix-ui/react-dialog';
import { AnimatePresence, motion } from 'framer-motion';
import { IconButton, Tooltip } from '../../../../..';
import type { HeaderProps } from '../../drawer.types';
const DrawerHeader = t0 => {
  const $ = _c(23);
  const {
    title,
    isNested,
    onBack,
    onClose,
    headerTooltip
  } = t0;
  const t1 = isNested ? "Go back" : "Close";
  const t2 = isNested ? onBack : onClose;
  const t3 = isNested ? IcoChevronLeft16 : IcoClose16;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = <RadixDialog.Close asChild={true}><IconButton aria-label={t1} onClick={t2} icon={t3} size="tiny" /></RadixDialog.Close>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isNested ? 25 : -25;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      opacity: 0,
      x: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 1,
      x: 0
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = isNested ? 25 : -25;
  let t9;
  if ($[7] !== t8) {
    t9 = {
      opacity: 0,
      x: t8
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      duration: 0.1,
      delay: 0.05
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = isNested ? "nested" : "main";
  let t12;
  if ($[10] !== title) {
    t12 = <RadixDialog.Title asChild={true}><h2 className="text-center truncate text-label-2">{title}</h2></RadixDialog.Title>;
    $[10] = title;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t11 || $[13] !== t12 || $[14] !== t6 || $[15] !== t9) {
    t13 = <AnimatePresence mode="wait" initial={false}><motion.div initial={t6} animate={t7} exit={t9} transition={t10} key={t11} className="flex-1 px-4">{t12}</motion.div></AnimatePresence>;
    $[12] = t11;
    $[13] = t12;
    $[14] = t6;
    $[15] = t9;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== headerTooltip) {
    t14 = headerTooltip && <RadixDialog.Description asChild={true}><Tooltip content={headerTooltip.text} aria-label={headerTooltip.triggerAriaLabel ?? headerTooltip.text}>{headerTooltip?.iconComponent ? <headerTooltip.iconComponent /> : <IcoInfo24 />}</Tooltip></RadixDialog.Description>;
    $[17] = headerTooltip;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t13 || $[20] !== t14 || $[21] !== t4) {
    t15 = <div className="grid grid-cols-[auto_1fr_auto] h-11 px-2 items-center border-b border-tertiary border-solid">{t4}{t13}{t14}</div>;
    $[19] = t13;
    $[20] = t14;
    $[21] = t4;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
};
export default DrawerHeader;